import React from 'react';
import PropTypes from 'prop-types';
import {checkNullStr, isBoolTrue} from "../utils/ReactUtils";
import {Label} from "../index";
import {THEME} from "../config/FusionConfig";

/**Create a circle-loader with single border*/
const CircleLoading = React.memo(({
                                      wrapperClassName = "",
                                      widthClass = "100",
                                      className = "",
                                      labelClassName = "",
                                      sizeVariant = "",
                                      variant = THEME,
                                      size = "34px",
                                      borderWidth = "5px",
                                      labelFontSize = "13px",
                                      wrapperHeight = "100%",
                                      justifyAt = "center",
                                      alignAt = "center",
                                      label,
                                      center = true,
                                      showLabel = true,
                                      style = {},
                                      wrapperStyle = {},
                                      labelStyle = {},
                                  }) => {
    const TAG = "CircleLoading";

    return (<>
            <div
                className={`p-0 m-1x d-flex 
                ${isBoolTrue(center) ? `w-${widthClass} jc-${justifyAt} al-${alignAt} transition` : ''} 
                ${wrapperClassName}`}
                style={{
                    height: wrapperHeight,
                    ...wrapperStyle
                }}
            >
                <div className={'m-0 p-0'} style={{height: wrapperHeight}}>
                    <div className={`simple-loader-wrapper p-1x m-0 ${className}`}
                         style={{height: wrapperHeight, ...style}}>
                        <div className={`simple-loader transition ${sizeVariant} ${variant} `}
                             style={{
                                 width: size,
                                 height: size,
                                 borderWidth: borderWidth,
                                 ...style
                             }}
                        />
                    </div>

                    {isBoolTrue(showLabel) && checkNullStr(label) && <div className={'m-0 p-0 mt-2x'}>
                        <Label className={`w-100 text-dark px-2 py-1 m-0 ${labelClassName}`} fontSize={labelFontSize} style={{...labelStyle}}>
                            {label}
                        </Label>
                    </div>}
                </div>
            </div>
        </>
    )
});
CircleLoading.propTypes = {
    className: PropTypes.string,
    wrapperClassName: PropTypes.string,
    labelClassName: PropTypes.string,
    borderWidth: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf(['60px'])]),
    variant: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf(['theme'])]),
    sizeVariant: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf(['xs', 'sm', '', 'lg', 'xl', 'xxl'])]),
    style: PropTypes.object,
    wrapperStyle: PropTypes.object,
    wrapperHeight: PropTypes.string,
    justifyAt: PropTypes.string,
    alignAt: PropTypes.string,
    label: PropTypes.string,
    labelStyle: PropTypes.object,
    labelFontSize: PropTypes.string,
    center: PropTypes.bool,
    showLabel: PropTypes.bool,
};
export default CircleLoading;
